module.exports = __webpack_public_path__ + "img/yjcd_bg.e6a15f21.png";